import { useState } from 'react'

export const useBooleanState = (initial = false) => {
  const [value, setState] = useState(initial)
  const setTrue = () => setState(true)
  const setFalse = () => setState(false)
  const toggle = () => setState((prev) => !prev)

  return { setFalse, setTrue, value, toggle }
}
